export default function Input({
  label = "",
  isNecessary = false,
  inputSample = "",
  type = "",
  id = "",
  name = "",
  isReadOnly = true,
  isAuotComplete = false,
  isLTR = false,
  isNumeric = false,
  max,
  onChange,
  value,
}) {
  return (
    <div className="w-full flex flex-col gap-1">
      <label
        htmlFor={id}
        className="text-sm text-zi-text-light/50 dark:text-zi-text-dark/50"
      >
        {label}
        {isNecessary && <sup className="text-zi-red-dark/100">*</sup>}
      </label>
      <input
        defaultValue={value === undefined ? inputSample : undefined}
        value={value}
        type={type}
        id={id}
        name={name}
        readOnly={isReadOnly}
        autoComplete={isAuotComplete}
        inputmode={isNumeric ? "numeric" : undefined}
        pattern={isNumeric ? "[0-9]*" : undefined}
        max={max}
        onInput={onChange}
        className={
          "w-full text-right bg-transparent outline-none rounded-md p-1 text-base " +
          "text-zi-text-light dark:text-zi-text-dark border border-zi-border-light dark:border-zi-border-dark " +
          "hocus:ring-1 hocus:ring-zi-border-light hocus:dark:ring-zi-border-dark " +
          "hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark " +
          (isLTR ? "[direction:ltr]" : "")
        }
      />
    </div>
  );
}
